module.exports = __webpack_public_path__ + "static/img/files.63c7167c.svg";